interface Property {
    field: string;
    values: PropertyValue[];
}

interface PropertyValue {
    id    : any;
    label : string;
}

class Yes implements PropertyValue {
    id  = true;
    label = 'yes';
}

class No implements PropertyValue {
    id = false;
    label = 'no';
}

class YesOrNo implements Property {
    field: string;
    values: PropertyValue[];

    constructor(field: string) {
        this.field = field;
        this.values = [
            new Yes(),
            new No()
        ]
    }
}

class Activity implements Property {
    field: string;
    values: PropertyValue[];

    constructor(field: string) {
        this.field = field;
        this.values = [
            {
                id : '0',
                label : 'Less than 1 day'
            },
            {
                id : '1-3',
                label : 'Between 1 and 3 days'
            },
            {
                id : '4-7',
                label : 'Between 4 and 7 days'
            },
            {
                id : '8-14',
                label : 'Between 8 and 14 days'
            },
            {
                id : '15-30',
                label : 'Between 15 and 30 days'
            },
            {
                id : '>30',
                label : 'More than 30 days'
            }
        ]
    }
}

export {
    Property,
    PropertyValue,
    YesOrNo,
    Activity
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/schemas/components/properties.models.ts